export default "__VITE_ASSET__NqWiOCT$__"